webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(21);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(8);
	
	__webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "arrow-left-icon",
	  data: function data() {
	    var iconTitle = this.title ? this.title : "Arrow left icon";
	
	    return {
	      iconTitle: iconTitle
	    };
	  },
	
	  props: {
	    title: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "arrow-right-icon",
	  data: function data() {
	    var iconTitle = this.title ? this.title : "Arrow right icon";
	
	    return {
	      iconTitle: iconTitle
	    };
	  },
	
	  props: {
	    title: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "lock-icon",
	  data: function data() {
	    var iconTitle = this.title ? this.title : "Lock icon";
	
	    return {
	      iconTitle: iconTitle
	    };
	  },
	
	  props: {
	    title: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "sort-alphabetical-icon",
	  data: function data() {
	    var iconTitle = this.title ? this.title : "Sort alphabetical icon";
	
	    return {
	      iconTitle: iconTitle
	    };
	  },
	
	  props: {
	    title: {
	      type: String
	    }
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueDraggableTags = __webpack_require__(22);
	
	var _vueDraggableTags2 = _interopRequireDefault(_vueDraggableTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    VueDraggableTags: _vueDraggableTags2.default
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(11);
	
	var _vuedraggable = __webpack_require__(30);
	
	var _vuedraggable2 = _interopRequireDefault(_vuedraggable);
	
	var _lock = __webpack_require__(19);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _arrowLeft = __webpack_require__(17);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(18);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _sortAlphabetical = __webpack_require__(20);
	
	var _sortAlphabetical2 = _interopRequireDefault(_sortAlphabetical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'vue-draggable-tags',
	  components: {
	    draggable: _vuedraggable2.default,
	    LockIcon: _lock2.default,
	    ArrowLeftIcon: _arrowLeft2.default,
	    ArrowRightIcon: _arrowRight2.default,
	    SortAlphabeticalIcon: _sortAlphabetical2.default
	  },
	  data: function data() {
	    return {
	      selected: {
	        tags: [],
	        editable: true,
	        cloneable: false,
	        droppable: true
	      },
	      available: {
	        tags: [{ tag: "Go", slug: "go", fixed: true }, { tag: "PHP", slug: "php", fixed: true }, { tag: "R", slug: "r", fixed: true }, { tag: "Kotlin", slug: "kotlin", fixed: false }, { tag: "Java", slug: "java", fixed: false }, { tag: "C++", slug: "c--", fixed: false }, { tag: "JavaScript", slug: "javascript", fixed: false }, { tag: "C#", slug: "c-", fixed: false }, { tag: "C", slug: "c", fixed: false }, { tag: "Python", slug: "phyton", fixed: false }],
	        editable: true,
	        cloneable: false,
	        droppable: true
	      },
	      isDragging: false,
	      delayedDragging: false
	    };
	  },
	
	  methods: {
	    orderList: function orderList(datalist) {
	      datalist.sort(function (one, two) {
	        return one.tag.localeCompare(two.tag);
	      });
	    },
	    onClick: function onClick(index, from, to) {
	      var current = from.tags[index];
	      if (!current.fixed && from.editable && to.editable && to.droppable) {
	        if (from.cloneable || to.tags.filter(function (e) {
	          return e.tag == current.tag;
	        }).length === 0) {
	          to.tags.push(current);
	        }
	        if (!from.cloneable) {
	          from.tags.splice(index, 1);
	        }
	      }
	    },
	    onMove: function onMove(_ref) {
	      var relatedContext = _ref.relatedContext,
	          draggedContext = _ref.draggedContext;
	
	      var relatedElement = relatedContext.element;
	      var draggedElement = draggedContext.element;
	      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
	    },
	    getOptions: function getOptions(place) {
	      return {
	        sort: true,
	        animation: 0,
	        group: {
	          name: 'tags',
	          pull: place.cloneable ? 'clone' : true,
	          put: place.droppable
	        },
	        disabled: !place.editable,
	        ghostClass: 'ghost'
	      };
	    }
	  },
	  watch: {
	    isDragging: function isDragging(newValue) {
	      var _this = this;
	
	      if (newValue) {
	        this.delayedDragging = true;
	        return;
	      }
	      this.$nextTick(function () {
	        _this.delayedDragging = false;
	      });
	    }
	  }
	};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(2),
	  /* template */
	  __webpack_require__(28),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(3),
	  /* template */
	  __webpack_require__(27),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(24),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(26),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(10)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(25),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(9)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(23),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-grid mdl-grid center-items"
	  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet",
	    attrs: {
	      "id": "sdt-selected-tags"
	    }
	  }, [_c('div', {
	    staticClass: "panel-body sdt-teal-switch"
	  }, [_c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-1"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected.editable),
	      expression: "selected.editable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-1"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.selected.editable) ? _vm._i(_vm.selected.editable, null) > -1 : (_vm.selected.editable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.selected.editable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.selected.editable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.selected.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.selected, "editable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("Enable drag and drop")])]), _vm._v(" "), _c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-2"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected.droppable),
	      expression: "selected.droppable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-2"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.selected.droppable) ? _vm._i(_vm.selected.droppable, null) > -1 : (_vm.selected.droppable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.selected.droppable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.selected.droppable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.selected.droppable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.selected, "droppable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("Enable dropping")])]), _vm._v(" "), _c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-3"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected.cloneable),
	      expression: "selected.cloneable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-3"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.selected.cloneable) ? _vm._i(_vm.selected.cloneable, null) > -1 : (_vm.selected.cloneable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.selected.cloneable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.selected.cloneable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.selected.cloneable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.selected, "cloneable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("\n            Enable cloning")])])]), _vm._v(" "), _c('button', {
	    staticClass: "sdt-sortable-btn sdt-sort-button mdl-button mdl-button--fab mdl-button--mini-fab mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-color--teal-100",
	    on: {
	      "click": function($event) {
	        _vm.orderList(_vm.selected.tags)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "material-icons  sdt-color-teal"
	  }, [_c('sort-alphabetical-icon')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp mdl-color--teal-500"
	  }, [_c('draggable', {
	    attrs: {
	      "element": "span",
	      "options": _vm.getOptions(_vm.selected),
	      "move": _vm.onMove
	    },
	    on: {
	      "start": function($event) {
	        _vm.isDragging = true
	      },
	      "end": function($event) {
	        _vm.isDragging = false
	      }
	    },
	    model: {
	      value: (_vm.selected.tags),
	      callback: function($$v) {
	        _vm.$set(_vm.selected, "tags", $$v)
	      },
	      expression: "selected.tags"
	    }
	  }, [_c('transition-group', {
	    staticClass: "mdl-list dragArea",
	    attrs: {
	      "type": "transition",
	      "name": 'flip-list',
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.selected.tags), function(element, index) {
	    return _c('li', {
	      key: element.tag,
	      staticClass: "sdt-tag mdl-cell mdl-cell--12-col sdt-tag-item mdl-list__item mdl-card mdl-shadow--2dp"
	    }, [_c('span', {
	      staticClass: "mdl-list__item-primary-content"
	    }, [_c('i', {
	      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-left",
	      class: [element.fixed ? 'sdt-color-red' : 'sdt-color-gray'],
	      on: {
	        "click": function($event) {
	          element.fixed = !element.fixed
	        }
	      }
	    }, [_c('lock-icon')], 1), _vm._v("\n                     " + _vm._s(element.tag) + "\n                  ")]), _vm._v(" "), _c('i', {
	      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-right sdt-color-teal",
	      on: {
	        "click": function($event) {
	          _vm.onClick(index, _vm.selected, _vm.available)
	        }
	      }
	    }, [_c('arrow-right-icon')], 1)])
	  }))], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet",
	    attrs: {
	      "id": "sdt-available-tags"
	    }
	  }, [_c('div', {
	    staticClass: "panel-body sdt-indigo-switch"
	  }, [_c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-4"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.available.editable),
	      expression: "available.editable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-4"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.available.editable) ? _vm._i(_vm.available.editable, null) > -1 : (_vm.available.editable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.available.editable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.available.editable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.available.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.available, "editable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("Enable drag and drop")])]), _vm._v(" "), _c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-5"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.available.droppable),
	      expression: "available.droppable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-5"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.available.droppable) ? _vm._i(_vm.available.droppable, null) > -1 : (_vm.available.droppable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.available.droppable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.available.droppable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.available.droppable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.available, "droppable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("Enable dropping")])]), _vm._v(" "), _c('label', {
	    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
	    attrs: {
	      "for": "switch-6"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.available.cloneable),
	      expression: "available.cloneable"
	    }],
	    staticClass: "mdl-switch__input",
	    attrs: {
	      "type": "checkbox",
	      "id": "switch-6"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.available.cloneable) ? _vm._i(_vm.available.cloneable, null) > -1 : (_vm.available.cloneable)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.available.cloneable,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.available.cloneable = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.available.cloneable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.$set(_vm.available, "cloneable", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mdl-switch__label"
	  }, [_vm._v("Enable cloning")])])]), _vm._v(" "), _c('button', {
	    staticClass: "sdt-sortable-btn sdt-sort-button mdl-button mdl-button--fab mdl-button--mini-fab mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-color--indigo-100",
	    on: {
	      "click": function($event) {
	        _vm.orderList(_vm.available.tags)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "material-icons sdt-color-indigo"
	  }, [_c('sort-alphabetical-icon')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp mdl-color--indigo-500"
	  }, [_c('draggable', {
	    attrs: {
	      "element": "span",
	      "options": _vm.getOptions(_vm.available),
	      "move": _vm.onMove
	    },
	    on: {
	      "start": function($event) {
	        _vm.isDragging = true
	      },
	      "end": function($event) {
	        _vm.isDragging = false
	      }
	    },
	    model: {
	      value: (_vm.available.tags),
	      callback: function($$v) {
	        _vm.$set(_vm.available, "tags", $$v)
	      },
	      expression: "available.tags"
	    }
	  }, [_c('transition-group', {
	    staticClass: "mdl-list dragArea",
	    attrs: {
	      "type": "transition",
	      "name": 'flip-list',
	      "tag": "ul"
	    }
	  }, _vm._l((_vm.available.tags), function(element, index) {
	    return _c('li', {
	      key: element.tag,
	      staticClass: "sdt-tag mdl-cell mdl-cell--12-col sdt-tag-item mdl-list__item mdl-card mdl-shadow--2dp"
	    }, [_c('span', {
	      staticClass: "mdl-list__item-primary-content"
	    }, [_c('i', {
	      staticClass: "sdt-tag-icon sdt-tag-icon-left material-icons sdt-color-indigo sdt-tag-icon",
	      on: {
	        "click": function($event) {
	          _vm.onClick(index, _vm.available, _vm.selected)
	        }
	      }
	    }, [_c('arrow-left-icon')], 1), _vm._v("\n                     " + _vm._s(element.tag) + "\n                  ")]), _vm._v(" "), _c('i', {
	      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-right",
	      class: [element.fixed ? 'sdt-color-red' : 'sdt-color-gray'],
	      on: {
	        "click": function($event) {
	          element.fixed = !element.fixed
	        }
	      }
	    }, [_c('lock-icon')], 1)])
	  }))], 1)], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "sdt-json-section mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet mdl-card sdt-color-teal mdl-color--teal-50"
	  }, [_c('pre', {
	    staticClass: "sdt-json-pre"
	  }, [_vm._v(_vm._s(_vm.selected.tags))])]), _vm._v(" "), _c('div', {
	    staticClass: "sdt-json-section mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet mdl-card mdl-card sdt-color-indigo mdl-color--indigo-50"
	  }, [_c('pre', {
	    staticClass: "sdt-json-pre"
	  }, [_vm._v(_vm._s(_vm.available.tags))])]), _vm._v(" "), _vm._m(2, false, false)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "https://github.com/Josantonius/vue-draggable-tags.git"
	    }
	  }, [_c('img', {
	    staticClass: "forkme",
	    attrs: {
	      "src": "https://josantonius.github.io/vue-draggable-tags/static/images/fork-me-on-github.png",
	      "alt": "Fork me on GitHub"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-cell mdl-cell--12-col"
	  }, [_c('div', {
	    staticClass: "sdt-header panel-heading"
	  }, [_c('h2', {
	    staticClass: "panel-title mdl-cell mdl-cell--12-col"
	  }, [_vm._v("\n            DRAG, DROP & SORT TAGS\n         ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mdl-cell mdl-cell--12-col"
	  }, [_c('footer', {
	    staticClass: "sdt-footer"
	  }, [_c('p', {
	    staticClass: "panel-title mdl-cell mdl-cell--12-col"
	  }, [_vm._v("Created with "), _c('a', {
	    staticClass: "mdl-color-text--teal-700",
	    attrs: {
	      "href": "https://getmdl.io/"
	    }
	  }, [_vm._v("MDL")]), _vm._v(", "), _c('a', {
	    staticClass: "mdl-color-text--teal-700",
	    attrs: {
	      "href": "https://vuejs.org/"
	    }
	  }, [_vm._v("Vue.js")]), _vm._v(" and "), _c('a', {
	    staticClass: "mdl-color-text--teal-700",
	    attrs: {
	      "href": "https://github.com/SortableJS/Vue.Draggable"
	    }
	  }, [_vm._v("Vue.Draggable")]), _vm._v("."), _c('br'), _vm._v("© 2017 "), _c('a', {
	    staticClass: "mdl-color-text--teal-700",
	    attrs: {
	      "href": "https://github.com/Josantonius"
	    }
	  }, [_vm._v("Josantonius")])])])])
	}]}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "material-design-icon",
	    attrs: {
	      "id": "lock-icon",
	      "role": "img",
	      "aria-labelledby": "lock-icon-title"
	    }
	  }, [_c('svg', {
	    staticClass: "material-design-icon__svg",
	    attrs: {
	      "width": "24",
	      "height": "24",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('title', {
	    attrs: {
	      "id": "lock-icon-title"
	    }
	  }, [_vm._v(_vm._s(_vm.iconTitle))]), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('vue-draggable-tags')], 1)
	},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "material-design-icon",
	    attrs: {
	      "id": "sort-alphabetical-icon",
	      "role": "img",
	      "aria-labelledby": "sort-alphabetical-icon-title"
	    }
	  }, [_c('svg', {
	    staticClass: "material-design-icon__svg",
	    attrs: {
	      "width": "24",
	      "height": "24",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('title', {
	    attrs: {
	      "id": "sort-alphabetical-icon-title"
	    }
	  }, [_vm._v(_vm._s(_vm.iconTitle))]), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M9.25,5L12.5,1.75L15.75,5H9.25M15.75,19L12.5,22.25L9.25,19H15.75M8.89,14.3H6L5.28,17H2.91L6,7H9L12.13,17H9.67L8.89,14.3M6.33,12.68H8.56L7.93,10.56L7.67,9.59L7.42,8.63H7.39L7.17,9.6L6.93,10.58L6.33,12.68M13.05,17V15.74L17.8,8.97V8.91H13.5V7H20.73V8.34L16.09,15V15.08H20.8V17H13.05Z"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "material-design-icon",
	    attrs: {
	      "id": "arrow-right-icon",
	      "role": "img",
	      "aria-labelledby": "arrow-right-icon-title"
	    }
	  }, [_c('svg', {
	    staticClass: "material-design-icon__svg",
	    attrs: {
	      "width": "24",
	      "height": "24",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('title', {
	    attrs: {
	      "id": "arrow-right-icon-title"
	    }
	  }, [_vm._v(_vm._s(_vm.iconTitle))]), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "material-design-icon",
	    attrs: {
	      "id": "arrow-left-icon",
	      "role": "img",
	      "aria-labelledby": "arrow-left-icon-title"
	    }
	  }, [_c('svg', {
	    staticClass: "material-design-icon__svg",
	    attrs: {
	      "width": "24",
	      "height": "24",
	      "viewBox": "0 0 24 24"
	    }
	  }, [_c('title', {
	    attrs: {
	      "id": "arrow-left-icon-title"
	    }
	  }, [_vm._v(_vm._s(_vm.iconTitle))]), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
	    }
	  })])])
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.f903ada3a70728fb4d47.js